// @flow

// Vendors
import React from 'react';
import classnames from 'classnames';

// types
import { InputType } from '../../../types';

const InputPhone = ({ label, ...props }: InputType) => (
  <>
    <label htmlFor={props.id} className="form__label">
      {label}
    </label>
    <input type="tel" className="form__input" {...props} />
  </>
);

InputPhone.defaultProps = {
  label: 'Phone Number',
  name: 'phone'
};

export default InputPhone;
